/**
 * Extracts display name and role from an option
 * @param {Object} option - The option object
 * @returns {Object} - Object containing displayName and displayRole
 */
export const getDisplayData = (option) => {
  return {
    displayName: option.label || option.name || '',
    displayRole: option.roleName || option.role || '',
  };
};

/**
 * Determines if docId should be shown
 * @param {Object} option - The option object
 * @returns {boolean} - True if docId should be shown, false otherwise
 */
export const shouldShowDocId = (option) => {
  return Boolean(option.docId && option.docId.trim && option.docId.trim() !== '');
};

